<div class="reactivate-content">
  <h4 class="modal-title">Reactivate Delivery</h4>

  <ion-buttons slot="secondary" class="modal-buttons-block">
    <ion-button (click)="onSubmit()" class="modal-button submit">
      <i class="fas fa-check-circle modal-icon"></i>
      Submit
    </ion-button>

    <ion-button (click)="onCancel()" class="modal-button cancel">
      <i class="far fa-times-circle modal-icon"></i>
      Cancel
    </ion-button>
  </ion-buttons>

  <p class="modal-text">Please click on the submit button to request to reactivate this delivery.</p>
  <p class="modal-text">For any further information please contact support at
    <a href="mailto:promo.support&#64;sonymusic.com">promo.support&#64;sonymusic.com</a>

  </p>
</div>
